import {styled} from "styled-components";

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
